<div class="sign-up-container">
  <img class="logo" src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />

  <div class="header-text">
    Welcome to FleetOperate<br />Driver Account Sign up
  </div>

  @if (errorMessage) {
    <mat-error  class="margin-bottom-sm">{{ errorMessage }}</mat-error>
  }
  @if (successMessage) {
    <mat-label  class="margin-bottom-sm"
    data-test="signup-successful-message">{{ successMessage }}</mat-label>
  }
  <form [formGroup]="form" #signupForm="ngForm" (ngSubmit)="onSubmit(signupForm)" class="sign-up-form">
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <input matInput #firstName formControlName="firstName" maxlength="20" data-test="firstname-form-field" />
      <mat-label>First Name</mat-label>
      @if (form.get('firstName')?.touched && form.get('firstName')?.invalid) {
        <mat-error>
          {{ getFirstNameErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <input matInput formControlName="lastName" maxlength="20" data-test="lastname-form-field" />
      <mat-label>Last Name</mat-label>
      @if (form.get('lastName')?.touched && form.get('lastName')?.invalid) {
        <mat-error>
          {{ getLastNameErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <input type="text" inputmode="email" matInput formControlName="email" data-test="email-form-field"
        [readonly]="driverEmail && !isCancelled" autocomplete="off" />
      <mat-label>Email</mat-label>
      @if (form.get('email')?.touched && form.get('email')?.invalid) {
        <mat-error>
          {{ getEmailErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <mat-hint align="start">###-###-####</mat-hint>
      <input matInput appPhoneMask maxlength="12" formControlName="mobileNumber"
        data-test="contact-number-form-field" />
      <mat-label>Mobile Number</mat-label>
      @if (form.get('mobileNumber')?.touched && form.get('mobileNumber')?.invalid) {
        <mat-error>
          {{ getMobileNumberErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
        data-test="password-form-field" autocomplete="off" />
      <mat-label>Password</mat-label>
      <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
        hidePassword ? 'visibility' : 'visibility_off'
      }}</mat-icon>
    </mat-form-field>
    @if ((form.get('password')?.touched || form.get('password')?.dirty) && form.get('password')?.invalid) {
      <div class="password-text">
        Your password must contain at least:
        <ul>
                <li [ngClass]="
            form.get('password')?.hasError('hasLength') || form.get('password')?.errors?.['required'] || loading ? 'text-error' : 'text-good'
          ">
            8 characters
          </li>
          <li
            [ngClass]="form.get('password')?.hasError('hasUpper') || form.get('password')?.errors?.['required'] || loading ? 'text-error' : 'text-good'">
            1 uppercase letter
          </li>
          <li
            [ngClass]="form.get('password')?.hasError('hasLower') || form.get('password')?.errors?.['required'] || loading ? 'text-error' : 'text-good'">
            1 lowercase letter
          </li>
                <li [ngClass]="
            form.get('password')?.hasError('hasNumber') || form.get('password')?.errors?.['required'] || loading ? 'text-error' : 'text-good'
          ">
            1 number
          </li>
                <li [ngClass]="
            form.get('password')?.hasError('hasSpecial') || form.get('password')?.errors?.['required'] || loading ? 'text-error' : 'text-good'
          ">
            1 special character (! &#64; # $ % ^ & *)
          </li>
          @if (form.get('password')?.hasError('invalidCharacters')) {
            <li
              [ngClass]="form.get('password')?.hasError('invalidCharacters') ? 'text-error' : 'text-good'">
              No special characters are allowed other than ! &#64; # $ % ^ & *
            </li>
          }
        </ul>
      </div>
    }
    <div class="align-self-center padding-top-md terms-text">
      By clicking Sign up, you agree to our
      <a [routerLink]="[]" (click)="onNavigateToTermsConditions()">Terms and Conditions</a> and
      <a [routerLink]="[]" (click)="onNavigateToPrivacyStatement()">Privacy Statement</a>.
    </div>
    <div class="full-width padding-top-sm">
      <button class="full-width margin-bottom sign-up-button" mat-raised-button color="primary" type="submit"
        data-test="signup-button" [disabled]="loading || !form.valid">
        Sign up
      </button>
    </div>
  </form>

  <div class="login-redirect">
    Already have an account? <a (click)="onNavigateToSignIn()" class="login-link">Log in</a>
  </div>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>